import { render, staticRenderFns } from "./JobCardDelivery.vue?vue&type=template&id=19719111"
import script from "./JobCardDelivery.vue?vue&type=script&lang=js"
export * from "./JobCardDelivery.vue?vue&type=script&lang=js"
import style0 from "./JobCardDelivery.vue?vue&type=style&index=0&id=19719111&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports